import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { useConfigUI } from '@/features/config/context'
import useDeleteCisFertigation from '@/features/config/hooks/cisFertigation/useDeleteCisFertigation'
import { debounce } from 'lodash'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
}

const DeleteCisFertigationModal = ({ id }: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()
  const { mutate: deleteFertigation, isLoading: loadingDelete } =
    useDeleteCisFertigation()

  const handleDeleteFertigation = debounce(async () => {
    if (!id) return
    deleteFertigation({ id })
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('dataConfigDeleteFertigation?')}
      text={t('fertigationDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteFertigation}
      isLoading={loadingDelete}
    />
  )
}

export default DeleteCisFertigationModal
